import { render, staticRenderFns } from "./AppPrivacyIcon.vue?vue&type=template&id=19c8b1c5&"
import script from "./AppPrivacyIcon.vue?vue&type=script&lang=js&"
export * from "./AppPrivacyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports